<template>
    <div>
        <PrismEditor
            ref="editor"
            line-numbers
            class="css-editor"
            placeholder="// put your css here"
            :model-value="modelValue"
            :highlight="highlighter"
            @update:modelValue="$emit('update:modelValue', $event)"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { PrismEditor } from "vue-prism-editor";
import { highlight, languages } from "prismjs";

import "vue-prism-editor/dist/prismeditor.min.css";
import "prismjs/components/prism-css";
import "prismjs/themes/prism-tomorrow.css";

export default defineComponent({
    name: "CssEditor",
    components: {
        PrismEditor
    },

    props: {
        modelValue: {
            type: String
        }
    },

    emits: ["update:modelValue"],

    mounted() {
        (this.$refs.editor as typeof PrismEditor).$refs.textarea.focus();
    },

    methods: {
        highlighter(code: string) {
            return highlight(code, languages.css, "css");
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

/* required class */
.css-editor {
    color: $cmp-dark-font-color;
    background-color: $cmp-dark-input-bg-color;
    border-color: $darktheme20;

    font-family:
        Fira code,
        Fira Mono,
        Consolas,
        Menlo,
        Courier,
        monospace;
    font-size: $font-size-base;
    line-height: $line-height-base;
    padding: $spacing-smaller;
    min-height: 4em;
}

/* optional class for removing the outline */
.prism-editor__textarea {
    outline: none;
}
</style>
